import * as React from 'react';
import AmazonAccountSelect from '../DialogComponents/AmazonAccountSelect';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';
import connectWithRouter from '../../redux/connectWithRouter';
import {StoreState} from '../../../../App/initialStore';
import * as _ from 'lodash';
import AmazonSitesSelect from '../DialogComponents/AmazonSitesSelect';
import createComputed from 'cl-form/createComputed';
import {getAmazonSellerFirstSite, getSellerSites} from '../../../../MyAccount/AmazonListings/amazonListingHelpers';
import {formValueSelector, change} from 'redux-form';

export interface PublishToAmazonFormData {
  sellerId: string;
  site: string;
}

export type PublishToAmazonDialogProps = SpecificFormDialogProps<
  PublishToAmazonFormData,
  {sellerId: string; change: typeof change}
>;

class PublishToAmazonDialog extends React.PureComponent<PublishToAmazonDialogProps> {
  updateSiteIfNeeded = _.memoize(sellerId => {
    this.props.change(GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_AMAZON_PAGE, 'site', getAmazonSellerFirstSite(sellerId));
  });

  amazonSiteSelectComponent = createComputed<PublishToAmazonFormData, 'sellerId'>({
    fieldNames: ['sellerId'],
    propsGenerator: ({sellerId}) => getSellerSites(sellerId),
  })((props: any) => {
    this.updateSiteIfNeeded(props.sellerId);
    return <AmazonSitesSelect {...props} />;
  });

  render() {
    const {sellerId, ...props} = this.props;
    return (
      <FormDialog<PublishToAmazonFormData>
        fullWidth
        maxWidth={'sm'}
        formName={GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_AMAZON_PAGE}
        initialValues={{sellerId, site: getAmazonSellerFirstSite(sellerId)}}
        text="Publishing products with variations to Amazon is not yet supported. Products with variations will appear with an error on next screen."
        title="Publish to Amazon"
        fields={[
          {component: AmazonAccountSelect, name: 'sellerId', label: 'Account'},
          {component: this.amazonSiteSelectComponent, name: 'site', label: 'Site'},
        ]}
        actions={
          <GeneralActions
            types={[GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_AMAZON_PAGE]}
            displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
            lastActionColor="primary"
          />
        }
        {...props}
      />
    );
  }
}

export default connectWithRouter(
  (state: StoreState) => {
    const formValuesSellerId = formValueSelector(GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_AMAZON_PAGE)(state, 'sellerId');
    const sellerId = formValuesSellerId ? formValuesSellerId : _.first(_.keys(state.accountPage.amazonAccounts));
    return {
      sellerId,
    };
  },
  {change}
)(PublishToAmazonDialog);
